/**
 * Check if the job has expiredAt
 * @param {string | undefined} expiredAt - The expiredAt date of the job
 * @returns {boolean} - True if the job has expiredAt
 */
export const hasExpiredAt = (
  expiredAt: string | undefined
): expiredAt is string => !!expiredAt;
